module.exports = __webpack_public_path__ + "img/silver-2.dc48fd86.png";